<template>
	<div>
		<div :class="'text-c mt-10 ' + 用户设置参数.编辑表单号码尺寸">
			<span class="c-orange ziti-b mr-10">员工编号：{{ yuangongbianhao }}</span>
		</div>

		<el-form :model="编辑表单" ref="编辑表单" :rules="编辑表单验证" :size="用户设置参数.编辑表单尺寸" label-width="auto">
			<mianban header="员工信息" yangshi="panel-primary" class="ma-10">
				<div>
					<el-row>
						<el-col :span="6">
							<el-form-item label="姓名" prop="姓名" required><el-input v-model="编辑表单.姓名" placeholder="请输入姓名"></el-input></el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="密码" prop="密码" required><el-input v-model="编辑表单.密码" placeholder="请输入密码"></el-input></el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="手机号码" prop="手机号码" required><el-input v-model="编辑表单.手机号码" placeholder="请输入手机号码"></el-input></el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="身份证" prop="身份证" required><el-input v-model="编辑表单.身份证" placeholder="请输入身份证"></el-input></el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="性别" prop="性别" required>
								<el-select v-model="编辑表单.性别" placeholder="性别" style="width: 100%;">
									<el-option label="男" value="男"></el-option>
									<el-option label="女" value="女"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="学历" prop="学历" required>
								<el-select v-model="编辑表单.学历" placeholder="学历" style="width: 100%;">
									<el-option label="小学" value="小学"></el-option>
									<el-option label="初中" value="初中"></el-option>
									<el-option label="中专" value="中专"></el-option>
									<el-option label="高中" value="高中"></el-option>
									<el-option label="大专" value="大专"></el-option>
									<el-option label="本科" value="本科"></el-option>
									<el-option label="研究生" value="研究生"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="婚姻" prop="婚姻" required>
								<el-select v-model="编辑表单.婚姻" placeholder="婚姻" style="width: 100%;">
									<el-option label="未婚" value="未婚"></el-option>
									<el-option label="已婚" value="已婚"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="驾驶证号" prop="驾驶证号" required><el-input v-model="编辑表单.驾驶证号" placeholder="请输入驾驶证号"></el-input></el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="出生日期" prop="出生日期" required>
								<el-date-picker v-model="编辑表单.出生日期" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="出生日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="紧急联系人" prop="紧急联系人" required><el-input v-model="编辑表单.紧急联系人" placeholder="请输入紧急联系人"></el-input></el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="住宿" prop="住宿" required>
								<el-select v-model="编辑表单.住宿" placeholder="住宿" style="width: 100%;">
									<el-option label="外宿" value="外宿"></el-option>
									<el-option label="住公司" value="住公司"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="所属区域" prop="所属区域" required>
								<el-select v-model="编辑表单.所属区域" placeholder="所属区域" style="width: 100%;">
									<el-option label="深圳" value="深圳"></el-option>
									<el-option label="东莞" value="东莞"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="入职日期" prop="入职日期" required>
								<el-date-picker v-model="编辑表单.入职日期" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="入职日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="账号状态" prop="账号状态" required>
								<el-select v-model="编辑表单.账号状态" placeholder="账号状态" style="width: 100%;">
									<el-option label="启用" value="启用"></el-option>
									<el-option label="禁用" value="禁用"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="员工状态" prop="员工状态" required>
								<el-select v-model="编辑表单.员工状态" placeholder="员工状态" style="width: 100%;">
									<el-option label="在职" value="在职"></el-option>
									<el-option label="离职" value="离职"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="首次登陆" prop="首次登陆" required>
								<el-select v-model="编辑表单.首次登陆" placeholder="首次登陆" style="width: 100%;">
									<el-option label="是" value="是"></el-option>
									<el-option label="否" value="否"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="部门职务" prop="部门职务" required>
								<el-cascader v-model="编辑表单.部门职务" :options="部门职务列表" :props="{ expandTrigger: 'hover' }" style="width: 100%;"></el-cascader>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="所属公司" prop="所属公司" required>
								<el-select v-model="编辑表单.所属公司" placeholder="所属公司" style="width: 100%;">
									<el-option v-for="v in 公司名称列表" :key="'新增表单所属公司'+v" :label="v" :value="v"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="籍贯" prop="籍贯" required><el-input v-model="编辑表单.籍贯" placeholder="请输入籍贯"></el-input></el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="现居住地" prop="现居住地" required><el-input v-model="编辑表单.现居住地" placeholder="请输入现居住地"></el-input></el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="职务描述"><el-input v-model="编辑表单.职务描述" placeholder="请输入职务描述"></el-input></el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="离职日期">
								<el-date-picker v-model="编辑表单.离职日期" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="离职日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>

						<el-col :span="6">
							<el-form-item label="手机短号"><el-input v-model="编辑表单.手机短号" placeholder="请输入手机短号"></el-input></el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="个人邮箱"><el-input v-model="编辑表单.个人邮箱" placeholder="请输入个人邮箱"></el-input></el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="6">
							<el-form-item label="试用期">
								<el-select v-model="编辑表单.试用期" placeholder="试用期" style="width: 100%;">
									<el-option label="是" value="是"></el-option>
									<el-option label="否" value="否"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="试用期开始日期">
								<el-date-picker
									v-model="编辑表单.试用期开始日期"
									type="date"
									value-format="yyyy-MM-dd"
									format="yyyy-MM-dd"
									placeholder="试用期开始日期"
									style="width: 100%;"
								></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="试用期结束日期">
								<el-date-picker
									v-model="编辑表单.试用期结束日期"
									type="date"
									value-format="yyyy-MM-dd"
									format="yyyy-MM-dd"
									placeholder="试用期结束日期"
									style="width: 100%;"
								></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="转正日期">
								<el-date-picker v-model="编辑表单.转正日期" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="转正日期" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="24">
							<el-form-item label="备注"><el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="编辑表单.备注" placeholder="请输入备注"></el-input></el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="8">
							<el-form-item label="头像">
								<ImgCutter @cutDown="cutDown" :cutWidth="400" :cutHeight="400" rate="1:1"></ImgCutter>
								<div class="mt-5">
								<el-avatar shape="square" :size="100" fit="fill" :src="编辑表单.头像网址"></el-avatar>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
				</div>

				<div class="text-c mt-10 mb-10">
					<el-button @click="关闭编辑页面()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="danger">关闭编辑页面</el-button>
					<el-button @click="保存()" :class="用户设置参数.编辑表单按钮尺寸" size="mini" type="primary">保存</el-button>
				</div>
			</mianban>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'yuangong-edit',
	props: {
		yuangongbianhao: Number
	},
	data() {
		return {
			用户设置参数: JSON.parse(localStorage.getItem('用户设置参数')),
			编辑表单: {
				姓名: '',
				密码: '',
				手机号码: '',
				身份证: '',
				性别: '',
				学历: '',
				婚姻: '',
				驾驶证号: '',
				出生日期: '',
				紧急联系人: '',
				住宿: '',
				所属区域: '',
				入职日期: '',
				账号状态: '',
				员工状态: '',
				首次登陆: '',
				部门职务: '',
				所属公司: '',
				籍贯: '',
				现居住地: '',
				职务描述: '',
				离职日期: '',
				手机短号: '',
				个人邮箱: '',
				试用期: '',
				试用期开始日期: '',
				试用期结束日期: '',
				转正日期: '',
				备注: '',
				头像: '',
				头像网址: ''
			},
			编辑表单验证: {
				姓名: [
					{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}
				],
				密码: [
					{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}
				],
				手机号码: [
					{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					},
					{
						pattern: /^1\d{10}$/,
						message: '请输入正确的11位手机号码',
						trigger: 'blur'
					}
				],
				身份证: [
					{
						required: true,
						message: '请输入身份证',
						trigger: 'blur'
					},
					{
						pattern: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/,
						message: '请输入正确的18位身份证号码',
						trigger: 'blur'
					}
				],
				性别: [
					{
						required: true,
						message: '请输入性别',
						trigger: 'blur'
					}
				],
				学历: [
					{
						required: true,
						message: '请输入学历',
						trigger: 'blur'
					}
				],
				婚姻: [
					{
						required: true,
						message: '请输入婚姻',
						trigger: 'blur'
					}
				],
				驾驶证号: [
					{
						required: true,
						message: '请输入驾驶证号',
						trigger: 'blur'
					}
				],
				出生日期: [
					{
						required: true,
						message: '请输入出生日期',
						trigger: 'blur'
					}
				],
				紧急联系人: [
					{
						required: true,
						message: '请输入紧急联系人',
						trigger: 'blur'
					}
				],
				住宿: [
					{
						required: true,
						message: '请输入住宿',
						trigger: 'blur'
					}
				],
				所属区域: [
					{
						required: true,
						message: '请输入所属区域',
						trigger: 'blur'
					}
				],
				入职日期: [
					{
						required: true,
						message: '请输入入职日期',
						trigger: 'blur'
					}
				],
				账号状态: [
					{
						required: true,
						message: '请输入账号状态',
						trigger: 'blur'
					}
				],
				员工状态: [
					{
						required: true,
						message: '请输入员工状态',
						trigger: 'blur'
					}
				],
				首次登陆: [
					{
						required: true,
						message: '请输入首次登陆',
						trigger: 'blur'
					}
				],
				部门职务: [
					{
						required: true,
						message: '请输入部门职务',
						trigger: 'blur'
					}
				],
				所属公司: [
					{
						required: true,
						message: '请输入所属公司',
						trigger: 'blur'
					}
				],
				籍贯: [
					{
						required: true,
						message: '请输入籍贯',
						trigger: 'blur'
					}
				],
				现居住地: [
					{
						required: true,
						message: '请输入现居住地',
						trigger: 'blur'
					}
				]
			},
			部门职务列表: [],
      公司名称列表:[],
		};
	},
	created: function() {
		this.查询信息();
		this.获取默认参数();
	},
	methods: {
		获取默认参数() {
			this.$http.post('get/yuangongxinxi/list').then(返回数据 => {
				this.部门职务列表 = 返回数据.部门职务;
        this.公司名称列表 = 返回数据.公司名称;
			});
		},
		查询信息() {
			this.$http
				.post('yuangong/yuangongxinxi/get', {
					员工编号2: this.yuangongbianhao
				})
				.then(返回数据 => {
					//console.log(返回数据);

					this.编辑表单.姓名 = 返回数据.员工信息.姓名;
					this.编辑表单.密码 = 返回数据.员工信息.密码;
					this.编辑表单.手机号码 = 返回数据.员工信息.手机号码;
					this.编辑表单.身份证 = 返回数据.员工信息.身份证;
					this.编辑表单.性别 = 返回数据.员工信息.性别;
					this.编辑表单.学历 = 返回数据.员工信息.学历;
					this.编辑表单.婚姻 = 返回数据.员工信息.婚姻;
					this.编辑表单.驾驶证号 = 返回数据.员工信息.驾驶证号;
					this.编辑表单.出生日期 = 返回数据.员工信息.出生日期;
					this.编辑表单.紧急联系人 = 返回数据.员工信息.紧急联系人;
					this.编辑表单.住宿 = 返回数据.员工信息.住宿;
					this.编辑表单.所属区域 = 返回数据.员工信息.所属区域;
					this.编辑表单.入职日期 = 返回数据.员工信息.入职日期;
					this.编辑表单.账号状态 = 返回数据.员工信息.账号状态;
					this.编辑表单.员工状态 = 返回数据.员工信息.员工状态;
					this.编辑表单.首次登陆 = 返回数据.员工信息.首次登陆;
					this.编辑表单.部门职务 = [返回数据.员工信息.部门, 返回数据.员工信息.职务];
					this.编辑表单.所属公司 = 返回数据.员工信息.所属公司;
					this.编辑表单.籍贯 = 返回数据.员工信息.籍贯;
					this.编辑表单.现居住地 = 返回数据.员工信息.现居住地;
					this.编辑表单.职务描述 = 返回数据.员工信息.职务描述;
					this.编辑表单.离职日期 = 返回数据.员工信息.离职日期;
					this.编辑表单.手机短号 = 返回数据.员工信息.手机短号;
					this.编辑表单.个人邮箱 = 返回数据.员工信息.个人邮箱;
					this.编辑表单.试用期 = 返回数据.员工信息.试用期;
					this.编辑表单.试用期开始日期 = 返回数据.员工信息.试用期开始日期;
					this.编辑表单.试用期结束日期 = 返回数据.员工信息.试用期结束日期;
					this.编辑表单.转正日期 = 返回数据.员工信息.转正日期;
					this.编辑表单.备注 = 返回数据.员工信息.备注;
					this.编辑表单.头像 = 返回数据.员工信息.头像;
					this.编辑表单.头像网址 = 返回数据.头像网址;
				});
		},
		关闭编辑页面() {
			//console.log(111);
			this.$emit('close', false);
		},
		保存() {
			this.$refs['编辑表单'].validate(valid => {
				if (valid) {
					this.$http
						.post('yuangong/yuangongxinxi/edit', {
							员工编号2: this.yuangongbianhao,
							姓名2: this.编辑表单.姓名,
							密码: this.编辑表单.密码,
							手机号码: this.编辑表单.手机号码,
							身份证: this.编辑表单.身份证,
							性别: this.编辑表单.性别,
							学历: this.编辑表单.学历,
							婚姻: this.编辑表单.婚姻,
							驾驶证号: this.编辑表单.驾驶证号,
							出生日期: this.编辑表单.出生日期,
							紧急联系人: this.编辑表单.紧急联系人,
							住宿: this.编辑表单.住宿,
							所属区域: this.编辑表单.所属区域,
							入职日期: this.编辑表单.入职日期,
							账号状态: this.编辑表单.账号状态,
							员工状态: this.编辑表单.员工状态,
							首次登陆: this.编辑表单.首次登陆,
							部门职务: this.编辑表单.部门职务,
							所属公司: this.编辑表单.所属公司,
							籍贯: this.编辑表单.籍贯,
							现居住地: this.编辑表单.现居住地,
							职务描述: this.编辑表单.职务描述,
							离职日期: this.编辑表单.离职日期,
							手机短号: this.编辑表单.手机短号,
							个人邮箱: this.编辑表单.个人邮箱,
							试用期: this.编辑表单.试用期,
							试用期开始日期: this.编辑表单.试用期开始日期,
							试用期结束日期: this.编辑表单.试用期结束日期,
							转正日期: this.编辑表单.转正日期,
							备注: this.编辑表单.备注,
							头像: this.编辑表单.头像
						})
						.then(response => {
							this.$message.success(response.信息);
							this.$emit('shuaxin_data');
							this.关闭编辑页面();
						});
				} else {
					//console.log(this.订单表单);
					console.log('下单验证不通过，请检查下单信息是否正确!');
					return false;
				}
			});
		},
		cutDown(文件) {
			console.log(文件);
			this.$http
				.post('yuangong/yuangongxinxi/touxiang', {
					图片编码: 文件.dataURL
				})
				.then(返回数据 => {
					console.log(返回数据);
					this.编辑表单.头像 = 返回数据.头像;
					this.编辑表单.头像网址 = 返回数据.头像网址;
					this.$message.success(返回数据.信息);
				});
		}
	}
};
</script>
